<ng-container>
  <div class="row">
    <div class="content">
      <span>
        {{
          cashcut.posName
            ? cashcut.posName + " (ID: " + cashcut.posId + ")"
            : cashcut.posId
        }}
      </span>
    </div>
    <div class="caption">
      <small>
        {{ "cashcut-details.cashcut.pos" | translate }}
      </small>
    </div>
  </div>

  <div class="row">
    <div class="content">
      <span>
        {{ cashcut.editedAt | date: "medium":undefined:language.key }}
      </span>
    </div>
    <div class="caption">
      <small>
        {{ "cashcut-details.cashcut.editedAt" | translate }}
      </small>
    </div>
  </div>

  <div class="row">
    <div class="content">
      <span>
        {{ cashcut.kassenschnittNr }}
      </span>
    </div>
    <div class="caption">
      <small>
        {{ "cashcut-details.cashcut.kassenschnittNr" | translate }}
      </small>
    </div>
  </div>

  <div class="row">
    <div class="content">
      <span>
        {{ cashcut.deviceId }}
      </span>
    </div>
    <div class="caption">
      <small>
        {{ "cashcut-details.cashcut.deviceId" | translate }}
      </small>
    </div>
  </div>

  <div class="row">
    <div class="content">
      <span>
        {{ cashcut.id }}
      </span>
    </div>
    <div class="caption">
      <small>
        {{ "cashcut-details.cashcut.id" | translate }}
      </small>
    </div>
  </div>
</ng-container>
